export default "__VITE_ASSET__SOr2IYDe__"